<div nz-dropdown
     [nzDropdownMenu]="companyWidgetMenu"
     nzTrigger="click"
     nzPlacement="bottomLeft"
     (nzVisibleChange)="onDropdownVisibleChange($event)"
     #companyDropdown="nzDropdown"
     class="d-flex align-items-center pointer company-switcher-trigger">

  <nz-avatar
    [nzSrc]="company()?.companyImage || company()?.pictureUrl"
    [nzText]="companyInitials()"
    nzSize="small"
    class="company-avatar mr-sm flex-shrink-0">
  </nz-avatar>

  <div class="text-left company-details">
    <div class="text-white fw-medium company-name-container" [class.collapsed]="collapsed()">
      <span class="company-name-text">{{ company().companyName || 'My Company' }}</span>
      <i nz-icon nzType="down" class="ml-xs dropdown-icon"></i>
    </div>
    <div class="text-white d-flex align-items-center company-id-container" (click)="$event.stopPropagation()">
      <span [class.licensed]="companyIsLicensed()" (click)="onCompanyIdClicked();$event.stopPropagation()" class="company-id-text">ID: {{ company().tenantCode || '—' }}</span>
      <i nz-icon
         nzType="copy"
         nzTheme="outline"
         class="ml-xs pointer copy-icon"
         [cdkCopyToClipboard]="company().tenantCode"
         nz-tooltip
         nzTooltipTitle="Copy ID"
         nzTooltipPlacement="bottom"></i>

      @if(isDemo()){
        <nz-tag nzColor="red">Demo</nz-tag>
      }
    </div>
  </div>
</div>

<nz-dropdown-menu #companyWidgetMenu="nzDropdownMenu">
  <ul nz-menu class="company-dropdown-menu">

    <li nz-menu-item class="ant-dropdown-menu-item-nohover" style="padding: 12px 16px;"
        (click)="$event.stopPropagation()">
      <nz-input-group [nzPrefix]="iconTpl" (click)="$event.stopPropagation()">
        <ng-template #iconTpl>
          <i nz-icon [nzType]="'search'"></i>
        </ng-template>
        <input (click)="$event.stopPropagation()"
               type="text"
               nz-input
               [ngModel]="searchCompanyText()"
               (ngModelChange)="onSearchChange($event)"
               [attr.placeholder]="'Search company...'" />
      </nz-input-group>
    </li>

    <li class="ant-dropdown-menu-item-nohover company-list-scroll-host"
        (click)="$event.stopPropagation()">
      <ul class="company-list-inner" (scroll)="onCompanyListScroll($event)">
        @if (loading()) {
          <li nz-menu-item disabled class="text-center company-list-status">
            <nz-spin nzSimple [nzSize]="'small'"></nz-spin>
            <div class="text-muted mt-sm">Loading companies...</div>
          </li>
        } @else {
          @for (item of companies(); track item?.tenantCode) {
            <li nz-menu-item (click)="switchCompany(item)">
              <div class="d-flex align-items-center w-100">
                <nz-avatar [nzSrc]="item.pictureUrl"
                           [nzText]="getInitials(item.companyName)"
                           nzSize="small"
                           class="mr-md flex-shrink-0">
                </nz-avatar>
                <div class="min-w-0">
                  <div class="company-item-name-row">
                    <span class="company-item-name" [title]="item.companyName">{{ item.companyName }}</span>
                    @if (item.isSample) {
                      <nz-tag nzColor="orange" class="text-xs flex-shrink-0">DEMO</nz-tag>
                    }
                  </div>
                  <div class="text-muted text-xs text-truncate">ID: {{ item.tenantCode }}</div>
                </div>
                @if (item.tenantCode === company().tenantCode) {
                  <i nz-icon nzType="check" class="text-primary ml-md flex-shrink-0"></i>
                }
              </div>
            </li>
          } @empty {
            <li nz-menu-item disabled class="text-center company-list-status">
              <span class="text-muted">No companies found</span>
            </li>
          }

          @if (loadingMore()) {
            <li nz-menu-item disabled class="text-center company-list-status company-list-status--compact">
              <nz-spin nzSimple [nzSize]="'small'"></nz-spin>
            </li>
          }
        }
      </ul>
    </li>

    <nz-divider style="margin: 0"></nz-divider>

    <li nz-menu-item (click)="goToMyCompanies('active')">
      <i nz-icon nzType="appstore" class="mr-sm"></i>
      My Companies
    </li>

    <li nz-menu-item (click)="goToMyCompanies('sample')">
      <i nz-icon nzType="database" class="mr-sm"></i>
      Sample Companies
    </li>

    <li nz-menu-item (click)="create.show()">
      <i nz-icon nzType="plus-circle" class="mr-sm"></i>
      New Company
    </li>
  </ul>
</nz-dropdown-menu>

<app-create-company #create></app-create-company>
